var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"aria-label":_vm.$t('common.clear')},on:{"click":function($event){return _vm.$emit('click')}}},[_c('Icon',{attrs:{"type":"x","size":"12","line-height":"0.5"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }